<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <v-container class="toolbar__container">
      <v-form ref="form" v-model="formValidado">
        <v-row>
          <v-col cols="12" sm="12" md="3">
            <v-autocomplete
              v-model="empresaSelected"
              :items="empresas"
              item-text="razao_social"
              return-object
              clearable
              :label="$tc('company.self', 1)"
              @change="onEmpresaChanged"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="12" md="8">
            <v-autocomplete
              v-model="idEquipamentoSelected"
              :items="equipamentosSelect"
              item-text="cod_equipamento"
              item-value="id_equipamento"
              clearable
              :label="$tc('equipment.self', 1)"
              :disabled="equipamentosDisabled"
              :rules="[relatorioRules]"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4" md="1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  fab
                  color="primary darken-1"
                  class="white--text"
                  v-bind="attrs"
                  v-on="on"
                  @click="populaRelatorio"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('operation.search') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <!-- Current Equipment Info Card -->
    <v-card v-if="equipamentoAtual" class="mb-4" outlined>
      <v-card-title>
        <span class="headline" style="color: #4a4a4a">{{ $t('equipmentHistory.currentInfo') }}</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <strong>{{ $t('equipment.code') }}:</strong> {{ equipamentoAtual.cod_equipamento }}
          </v-col>
          <v-col cols="12" md="3">
            <strong>{{ $t('equipment.name') }}:</strong> {{ equipamentoAtual.nome_equipamento || '-' }}
          </v-col>
          <v-col cols="12" md="3">
            <strong>{{ $t('equipmentHistory.currentStatus') }}:</strong> {{ equipamentoAtual.status_atual || '-' }}
          </v-col>
          <v-col cols="12" md="3">
            <strong>{{ $t('equipmentHistory.currentKit') }}:</strong> 
            {{ equipamentoAtual.kit_atual_cod ? `${equipamentoAtual.kit_atual_cod} (${equipamentoAtual.kit_atual_nome})` : '-' }}
          </v-col>
          <v-col cols="12" md="3">
            <strong>{{ $t('equipmentHistory.installedBy') }}:</strong> {{ equipamentoAtual.usuario_instalacao || '-' }}
          </v-col>
          <v-col cols="12" md="3">
            <strong>{{ $t('equipmentHistory.installedDate') }}:</strong> {{ equipamentoAtual.dt_instalacao_formatado || '-' }}
          </v-col>
          <v-col cols="12" md="3">
            <strong>{{ $t('equipmentHistory.configuredBy') }}:</strong> {{ equipamentoAtual.usuario_configuracao || '-' }}
          </v-col>
          <v-col cols="12" md="3">
            <strong>{{ $t('equipmentHistory.configuredDate') }}:</strong> {{ equipamentoAtual.dt_configuracao_formatado || '-' }}
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <merus-data-table
      :headers="headers"
      :items="historicoSorted"
      sort-by="dt_evento_formatado"
      :sort-desc="true"
      item-key="id_historico_evento"
      dense
      class="elevation-7"
      locale="pt"
      :loading="loading"
      :loading-text="$t('system.messages.loading')"
      style="border-radius: 10px; margin-bottom: 10px; margin-top: 10px;"
      @update:sort-by="updateSort($event)"
      @update:sort-desc="updateSortDesc($event)"
    

 cod-tabela="RELHISTORICOEQUIPAMENTO" @update:headers="headers = $event">
      <template v-slot:toolbar>
        <CadastroToolbar
          :token="token"
          :title="$t('equipmentHistory.title')"
          :items="historicoSorted"
          csv-title="historicoequipamento"
          :pdf-title="$t('equipmentHistory.title')"
          :pdf-headers="headers"
          pdf-filename="historicoequipamento"
          :pdf-subtitle="razaoSocial"
          hide-search
        />
      </template>

      <template v-slot:item.tipo_evento="{ item }">
        {{ getEventTypeLabel(item.tipo_evento) }}
      </template>

      <template v-slot:item.status_change="{ item }">
        <span v-if="item.status_anterior && item.status_novo">
          {{ item.status_anterior }} → {{ item.status_novo }}
        </span>
        <span v-else-if="item.status_novo">
          → {{ item.status_novo }}
        </span>
        <span v-else-if="item.status_anterior">
          {{ item.status_anterior }} →
        </span>
        <span v-else>-</span>
      </template>

      <template v-slot:item.kit_change="{ item }">
        <span v-if="item.cod_kit_anterior && item.cod_kit_novo">
          {{ item.cod_kit_anterior }} → {{ item.cod_kit_novo }}
        </span>
        <span v-else-if="item.cod_kit_novo">
          → {{ item.cod_kit_novo }} ({{ item.nome_kit_novo }})
        </span>
        <span v-else-if="item.cod_kit_anterior">
          {{ item.cod_kit_anterior }} ({{ item.nome_kit_anterior }}) →
        </span>
        <span v-else>-</span>
      </template>
    </merus-data-table>
  </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import MerusDataTable from "../Tables/MerusDataTable.vue";
import CadastroToolbar from "../Toolbars/CadastroToolbar.vue";

export default {
  components: {
    MerusDataTable,
    CadastroToolbar,
  },
  data: () => ({
    headers: [],
    user: null,
    token: null,
    formValidado: false,
    loading: false,
    empresas: [],
    equipamentos: [],
    equipamentosSelect: [],
    empresaSelected: null,
    idEquipamentoSelected: null,
    equipamentosDisabled: false,
    historico: [],
    equipamentoAtual: null,
    sortBy: null,
    sortDesc: false,
  }),
  computed: {
    headersWithProperties() {
      return this.headers.map(header => ({
        ...header,
        filtrable: true,
        sortable: true
      }));
    },
    razaoSocial() {
      return this.empresaSelected ? this.empresaSelected.razao_social : this.$t('company.allTheCompanies');
    },
    historicoSorted() {
      if (!this.sortBy) {
        return this.historico;
      }
        
      return [...this.historico].sort((a, b) => {
        let result = 0;
        if (a[this.sortBy] > b[this.sortBy]) {
          return 1
        } else if (a[this.sortBy] == b[this.sortBy]) {
          result = 0;
        } else {
          result = -1;
        }
        return this.sortDesc ? -1 * result : result;
      });
    },
    relatorioRules() {
      return (v) => !!v || this.$t('equipmentHistory.validation.equipmentRequired');
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.initialize();
  },
  methods: {

    initialize() {
      this.populaEmpresas();
    },
    populaEmpresas() {
      apiController.request(apiController.endpoints.getallEmpresas, {
        onSuccess: (response) => {
          this.empresas = response.data;
        },
      });
    },
    onEmpresaChanged() {
      if (this.empresaSelected) {
        this.populaEquipamentosSelect();
      } else {
        this.populaEquipamentosSelect();
      }
      this.idEquipamentoSelected = null;
      this.equipamentoAtual = null;
      this.historico = [];
    },
    populaEquipamentosSelect() {
      apiController.request(apiController.endpoints.getallEquipamentos, {
        onSuccess: (response) => {
          this.equipamentos = response.data;
          if (this.empresaSelected) {
            this.equipamentosSelect = this.equipamentos.filter(
              (e) => e.id_empresa === this.empresaSelected.id_empresa
            );
          } else {
            this.equipamentosSelect = this.equipamentos;
          }
        },
      });
    },
    populaRelatorio() {
      this.$refs.form.validate();
      if (this.formValidado && this.idEquipamentoSelected) {
        this.loading = true;
        apiController.request(apiController.endpoints.getHistoricoequipamento, {
          params: { idEquipamento: this.idEquipamentoSelected },
          onSuccess: (response) => {
            if (response.data && response.data.length > 0) {
              // Get current equipment info from first row (all rows have same equipment data)
              this.equipamentoAtual = response.data[0];
              // Filter out rows without history events (null id_historico_evento means no event)
              // But keep at least one row if no history exists to show current info
              const historyRows = response.data.filter((item) => item.id_historico_evento !== null);
              if (historyRows.length > 0) {
                this.historico = historyRows;
              } else {
                // No history yet, but we have equipment info
                this.historico = [];
              }
            } else {
              // If no data returned, try to get equipment info separately
              this.historico = [];
              this.equipamentoAtual = null;
            }
            this.loading = false;
          },
          onError: () => {
            this.loading = false;
          },
        });
      }
    },
    getEventTypeLabel(tipoEvento) {
      if (!tipoEvento) return '-';
      const labels = {
        'STATUS_CHANGE': this.$t('equipmentHistory.eventTypes.statusChange'),
        'KIT_ASSIGN': this.$t('equipmentHistory.eventTypes.kitAssign'),
        'KIT_REMOVE': this.$t('equipmentHistory.eventTypes.kitRemove'),
        'INSTALL': this.$t('equipmentHistory.eventTypes.install'),
        'CONFIGURE': this.$t('equipmentHistory.eventTypes.configure'),
      };
      return labels[tipoEvento] || tipoEvento;
    },
    updateSort(event) {
      this.sortBy = event;
    },
    updateSortDesc(event) {
      this.sortDesc = event;
    },
  },
};
</script>

<style scoped>
.toolbar__container {
  padding: 0;
}
</style>
